import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from "@angular/router";
import { Observable, forkJoin} from 'rxjs';
import { SelectItem } from "primeng/api";
import { BaseComponent, Message, ReportsQueueTableComponent, AuthenticationService, UserProfile } from 'iui-iconectiv-lib';
import { SearchModelService, InputParams } from '../search/search-model.service';
import { ReportForm, ReportData, Report } from '../shared/model/report-form.model';
import { Account } from '../shared/model/account.model';
import {SummaryService} from "../summary/summary.service";
import { ReportsService } from './reports.service';
import { RefdataService } from '.././shared/refdata.service';
import { ReportRefereneces } from './report-dropdowns-ref';
import * as moment from 'moment-timezone';
// import 'moment-timezone';



// error message
const ERROR_MESSAGE = "The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.";

@Component({
  selector: 'app-reports-queue',
  templateUrl: './reports-queue.component.html',
  styleUrls: ['./reports-queue.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportsQueueComponent extends BaseComponent implements OnInit, AfterViewInit {

  userProfile: UserProfile = new UserProfile();
  accountProfile: Account = new Account();
  // report: Report = new Report();
  fileData: File;
  display: boolean = false;
  searchBy: string = "enter";
  portDatesInvalid: boolean = false;
  reportParam: any;
  reportTypeVal: string;
  reportTypeLabel: string;

  fromDatePortOut: Date;
  toDatePortOut: Date;
  fromDatePortIn: Date;
  toDatePortIn: Date;
  blkFromDate: Date;
  blkToDate: Date;

  maxDate: Date = new Date();
  minDate: Date = new Date();

  portOutActDisplay: SelectItem[] = [];
  portInActDisplay: SelectItem[] = [];
  regionsDisplay: SelectItem[] = [];
  spidDisplay: SelectItem[] = [];
  dateRangeDisplay: SelectItem[] = [];
  reportTypes: SelectItem[] = [];
  spidList: string[];

  // user input parameters
  inputParams = new InputParams();

  tnReport = new ReportForm();
  blockReport = new ReportForm();
  lrnReport = new ReportForm();
  portOutActivityReport = new ReportForm();
  portInActivityReport = new ReportForm();

  reportRef = new ReportRefereneces();

  

  DEFAULT_ERROR = "Error";
  PORT_DATE_ERROR = "Start date must be earlier than end date. (Format YYYY-MM-DD)";
  MSG_INVALID_LRN_SPIDS = 'The LRN ${num} is not associated with any SPIDS in your account. Please remove the LRN from the input.';
  UNAUTHORIZED_REPORT_ID = 'You are not authorized to view this report, since the report you are trying to view was requested by a different user.'

  @ViewChild('reportsTable') reportsTable: ReportsQueueTableComponent;
  // @ViewChild ('reportType', {static: false}) reportTypeTag: ElementRef;
  @ViewChild('fileElem') fileInput: ElementRef;
  // @ViewChild ('fileElemNpb', {static: false}) fileElemNpb: ElementRef;
  // @ViewChild('radioEnter', {static: false}) radioEnter: ElementRef;
  @ViewChild('iuimodalmsg') iuimodalmsg: any;
  @ViewChild('iuimsg') iuimsg: any;
  @ViewChild('tnForm') tnForm: NgForm;
  @ViewChild('blockForm') blockForm: NgForm;
  @ViewChild('lrnForm') lrnForm: NgForm;
  @ViewChild('portOutActivity') portOutActivity: NgForm;
  @ViewChild('portInActivity') portInActivity: NgForm;
  @ViewChild('reportDialog') reportDialog;

  constructor(
    private summaryService: SummaryService,
    private searchModelService: SearchModelService,
    private reportsService: ReportsService,
    private refDataService: RefdataService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private cdref: ChangeDetectorRef) {
    super();

    const BY_TN_RANGE = 'byTnRange';
    const BY_TN_FILE = 'byTnFile';
    
   }
  ngAfterViewInit(): void {
    this.iuimodalmsg.klass = 'show-display mx-auto';
    this.cdref.detectChanges();
  }

  ngOnInit() {

    let obs: Observable<any>[] = [];
    this.reportParam = this.route.snapshot.params['id'];
    this.dateRangeDisplay = this.reportRef.dateRangeDropdown;
    this.portOutActDisplay = this.reportRef.portOutActDropdown;
    this.portInActDisplay = this.reportRef.portInActDropdown;
    this.minDate.setDate(this.maxDate.getDate() - 90);

    obs.push(this.refDataService.getRefdata());
    obs.push(this.authService.getUserProfile());
    obs.push(this.summaryService.getMyAccount());

    forkJoin(obs).subscribe(results => {
      results.forEach(rsp => { 

        if(rsp.reportTypes) {
          this.reportTypes = rsp.reportTypes.map(a => {
            return { value: a.key, label: a.label };
          });
        }

        if(rsp.region) {
          this.regionsDisplay = rsp.region.map(a => {
            return { value: a.key, label: a.label };
          });
          this.reportTypeVal = this.reportTypes[0].value;
          this.reportTypeLabel = this.reportTypes[0].label;
          this.reportChange(this.reportTypeVal);
        }

        if (rsp.responseType === 'profile') {
            if (this.authService.isSuccessResponse(rsp)) {
              this.userProfile = rsp.data;
          }
        }

        if (rsp.spidsWithNames) {
          this.accountProfile = rsp.Account;
          this.spidDisplay = rsp.spidsWithNames.map(b => {
            return { value: b.key, label: b.label };
          });
        }
      });
    },
    error => {
      console.error(error);
    },
    () => {
      this.refresh();
    });


  }

  reportChange(report) {
    
    if (report) {
      this.reportTypeVal = report;
      this.reportTypeLabel = this.reportTypes.find(val => val.value == report).label;

      switch(report) {

        case "tn": 
          this.tnReport.report.reportType = report;
          this.tnReport.report.reportTypeLabel = this.reportTypeLabel;
          break;
        
        case "block":
          this.blockReport.report.reportType = report;
          this.blockReport.report.reportTypeLabel = this.reportTypeLabel;
          break;

        case "lrn":
          this.lrnReport.report.reportType = report;
          this.lrnReport.report.reportTypeLabel = this.reportTypeLabel;
          break;

        case "portOutActivity":
          this.portOutActivityReport.report.reportType = report;
          this.portOutActivityReport.report.reportTypeLabel = this.reportTypeLabel;
          break;

        case "portInActivity":
          this.portInActivityReport.report.reportType = report;
          this.portInActivityReport.report.reportTypeLabel = this.reportTypeLabel;
          break;
      }
    }
  }
  
  // methods support file upload
  processUploadedFile(files) {

    this.fileData = files[0];
    this.log.debug(files);

    this.inputParams.byTnFile.tnFileName = files[0]['name'];

    const fileExtension = this.inputParams.byTnFile.tnFileName.split('.').pop();
    if (fileExtension.toLowerCase() === 'csv' || fileExtension.toLowerCase() === 'txt') {
      const reader = new FileReader();
      reader.onload = () => {
        this.inputParams.byTnFile.input = reader.result as string;
        this.inputParams.byTnFile.valid = true;
        this.fileInput.nativeElement.value = ''; 
        // reset the value of <input>
      };

      reader.readAsText(files[0]);
    }

  }

  processUploadedFileNpb(files) {
    this.log.debug(files);
    this.inputParams.byNpbFile.tnFileName = files[0]['name'];

    const fileExtension = this.inputParams.byNpbFile.tnFileName.split('.').pop();
    if (fileExtension.toLowerCase() === 'csv' || fileExtension.toLowerCase() === 'txt') {
      const reader = new FileReader();
      reader.onload = () => {
        this.inputParams.byNpbFile.input = reader.result as string;
        this.inputParams.byNpbFile.valid = true;
        this.fileInput.nativeElement.value = ''; // reset the value of <input>
      };

      reader.readAsText(files[0]);
    }
  }

  showDialog() {
    this.display = true;
  }

  dialogClosed() {
    this.refresh();
  }

  refresh() {   
    this.portDatesInvalid = false;
    this.fileData = null;

    this.inputParams.reset();

    this.tnReport.reset();
    this.blockReport.reset();
    this.lrnReport.reset();
    this.portOutActivityReport.reset();
    this.portInActivityReport.reset();

    this.tnForm.form.reset();
    this.blockForm.form.reset({ enter:"enter" });
    this.lrnForm.form.reset();
    this.portOutActivity.form.reset({ dateRange: "last90Days" });
    this.portInActivity.form.reset({ dateRange: "last90Days" });

    this.portOutActivityReport.report.reportData.dateType = "last90Days";
    this.portInActivityReport.report.reportData.dateType = "last90Days";

    this.portOutActivityReport.report.reportData.spidList = [];
    this.portOutActivityReport.report.reportData.regionList = [];
    this.spidDisplay.forEach(spid => { this.portOutActivityReport.report.reportData.spidList.push(spid.value); });
    this.regionsDisplay.forEach(region => { this.portOutActivityReport.report.reportData.regionList.push(region.value)});

    this.portInActivityReport.report.reportData.spidList = [];
    this.portInActivityReport.report.reportData.regionList = [];
    this.spidDisplay.forEach(spid => { this.portInActivityReport.report.reportData.spidList.push(spid.value); });
    this.regionsDisplay.forEach(region => { this.portInActivityReport.report.reportData.regionList.push(region.value)});

    this.searchBy = "enter";
    this.reportTypeVal = this.reportTypes[0].value;
    this.reportTypeLabel = this.reportTypes[0].label;

  }

  queueReport() {

    switch(this.reportTypeVal) {

      case "tn": 
        this.searchByTnList();
        break;
      
      case "block":
        this.searchByTnsBlock();
        break;

      case "lrn":
        this.searchByLrnList();
        break;
      
      case "portOutActivity":
        this.searchByPortOutActivity();
        break;

      case "portInActivity":
        this.searchByPortInActivity();
        break;
    }


  }

  searchByTnList() {

    if (this.tnReport.report.reportName) {
      this.reportNameValidate(this.tnReport);
    }
    this.searchModelService.validateTnListRequest(this.inputParams.byTnFile, true);

    if (!this.tnReport.reportNameValid || !this.inputParams.byTnFile.valid) {
      return;
    }
    else {
      delete this.tnReport.report.reportData;
      this.saveRequest(this.tnReport.report);
    }

  }

  searchByTnsBlock() {
    this.blockReport.portDatesInvalid = false;
    this.cleanUpData(this.blockReport.report.reportData);
    if (this.blockReport.report.reportName) {
      this.reportNameValidate(this.blockReport);
    }

    if (this.blkFromDate) {
      this.blockReport.report.reportData.startDate = moment.tz(this.blkFromDate, 'America/New_York').utc().format('YYYY-MM-DD hh:mm:ss');
    }
    else { delete this.blockReport.report.reportData.startDate; }

    if (this.blkToDate) {
      this.blockReport.report.reportData.endDate = moment.tz(this.blkToDate,'America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
    }
    else { delete this.blockReport.report.reportData.endDate; }
    
    if (this.blockReport.report.reportData.startDate && this.blockReport.report.reportData.endDate) {
      this.blockReport.portDatesInvalid = this.validateCalander(this.blockReport.report);
    }

    if (this.searchBy === 'upload') {

      this.searchModelService.validateNpbListRequest(this.inputParams.byNpbFile);

      if (!this.blockReport.reportNameValid || !this.inputParams.byNpbFile.valid || this.blockReport.portDatesInvalid) {
        return;
      }
      this.blockReport.report.reportData.blockList = this.inputParams['byNpbFile'].restParams;
      delete this.fileData;
      this.cleanUpData(this.blockReport.report.reportData);
      this.saveRequest(this.blockReport.report);
    }
    else if (this.searchBy === 'enter') {

      this.searchModelService.validateNpbListRequest(this.inputParams.byNpb);

      if (!this.blockReport.reportNameValid || !this.inputParams.byNpb.valid || this.blockReport.portDatesInvalid) {
        return;
      }
      this.blockReport.report.reportData.blockList = this.inputParams['byNpb'].restParams;

      delete this.fileData;
      this.cleanUpData(this.blockReport.report.reportData);

      this.saveRequest(this.blockReport.report);
    }
  }

  searchByLrnList() {
    this.inputParams.byLrns.restParams = [];

    if (this.lrnReport.report.reportName) {
      this.reportNameValidate(this.lrnReport);
    }

    this.searchModelService.validateLrnListRequest(this.inputParams.byLrns);

    if (!this.lrnReport.reportNameValid || !this.inputParams.byLrns.valid) {
      return;
    }
    
    this.lrnReport.report.reportData.lrnList = this.inputParams['byLrns'].restParams;
    delete this.fileData;

    this.cleanUpData(this.lrnReport.report.reportData);

    this.reportsService.validateSpidsAndLrns(JSON.stringify(this.lrnReport.report.reportData.lrnList)).subscribe(rsp => {
      
      let accountSpids = this.accountProfile.associatedSpids;

      this.lrnReport.report.reportData.lrnList.forEach(lrn => {
        let lrnSpids = rsp.data[lrn];

        if (!lrnSpids) {
          this.inputParams.byLrns.boldText = this.DEFAULT_ERROR;
          this.inputParams.byLrns.errMsg = this.MSG_INVALID_LRN_SPIDS.replace('${num}', lrn);
          this.inputParams.byLrns.valid = false;
          return;
        }
        let spidIncluded = lrnSpids.some(e => accountSpids.includes(e));

        if (!spidIncluded) {
          this.inputParams.byLrns.boldText = this.DEFAULT_ERROR;
          this.inputParams.byLrns.errMsg = this.MSG_INVALID_LRN_SPIDS.replace('${num}', lrn);
          this.inputParams.byLrns.valid = false;
          return;
        }
      });
      if (this.inputParams.byLrns.valid) {
        this.saveRequest(this.lrnReport.report);
      }

    });
  }

  searchByPortOutActivity() {
    this.portOutActivityReport.portDatesInvalid = false;
    if (this.portOutActivityReport.report.reportName) {
      this.reportNameValidate(this.portOutActivityReport);
    }
    this.setCorrectDates(this.portOutActivityReport.report);

    if (this.portOutActivityReport.report.reportData.fromDate && this.portOutActivityReport.report.reportData.toDate) {
      this.portOutActivityReport.portDatesInvalid = this.validateCalander(this.portOutActivityReport.report);
    }

    if (!this.portOutActivityReport.reportNameValid || this.portOutActivityReport.portDatesInvalid) {
      return;
    }
    
    this.cleanUpData(this.portOutActivityReport.report.reportData);

    this.saveRequest(this.portOutActivityReport.report);
  }

  searchByPortInActivity() {

    this.portInActivityReport.portDatesInvalid = false;
    if (this.portInActivityReport.report.reportName) {
      this.reportNameValidate(this.portInActivityReport);
    }
    this.setCorrectDates(this.portInActivityReport.report);

    if (this.portInActivityReport.report.reportData.fromDate && this.portInActivityReport.report.reportData.toDate) {
      this.portInActivityReport.portDatesInvalid = this.validateCalander(this.portInActivityReport.report);
    }

    if (!this.portInActivityReport.reportNameValid || this.portInActivityReport.portDatesInvalid) {
      return;
    }
    
    this.cleanUpData(this.portInActivityReport.report.reportData);

    this.saveRequest(this.portInActivityReport.report);
  }

  saveRequest(report) {

    const reportTypeMsg = report.reportTypeLabel;
    const reportNameMsg = report.reportName;

    this.reportsService.requestReport(JSON.stringify(report), this.fileData).subscribe(data => {
      this.iuimsg.clearAll();
      const msg = new Message(`Success`, `Report Type ` + reportTypeMsg +` with Report Name ` + reportNameMsg +` has been requested. When your request has finished processing, an email will be sent to ${this.userProfile.email}.`);
      msg.autoHide = 10000;
      this.iuimsg.displaySuccess(msg);
      this.display = false;
      this.refresh();
      this.reportsTable.retrieveReports();
    
    },
    error => {
      this.log.error(`request report: get HttpError=${JSON.stringify(error)}`);
      this.iuimodalmsg.clearAll();
      this.displayError();
    });

  }

  cancelQueue() {
    this.display = false;
  }

    /**
   * call base class's displayErrorMessage() for error.
   */
  displayError() {
    this.iuimodalmsg.displayError(new Message('System Error', ERROR_MESSAGE));
  }

  // removes empty or null values from saving to the back end
  cleanUpData(reportForm) {

    Object.keys(reportForm).forEach((key) => (reportForm[key] == null || reportForm[key].length == 0) && delete reportForm[key]);
  }

  reportNameValidate(reportFormObj: ReportForm) {

    let str = reportFormObj.report.reportName;
    reportFormObj.reportNameValid = true;

    while (/[\.\-_ ]/.test(str.slice(0,1))) {
        str = str.slice(1);
    }

    if (/[~"#%&:<>*/\\?{}$!'@|]/g.test(str)) {
      reportFormObj.reportNameValid = false;
      reportFormObj.report.reportName = str;
      return;
    }
    
    else if (str === ""){
      reportFormObj.reportNameValid = false;
      reportFormObj.report.reportName = str;
      return;
    }

    else {
      reportFormObj.report.reportName = str;
    }

  }

  validateCalander(report): boolean{
    if (report.reportType === 'block') {
      return report.reportData.startDate > report.reportData.endDate;
    }
    else {
      return report.reportData.fromDate > report.reportData.toDate;
    }
 
  }

  setCorrectDates(report: Report) {
    let dateOption = report.reportData.dateType;
    let reportData = report.reportData;

    switch(dateOption) {

      case "last24Hours": {
          reportData.fromDate = moment.tz('America/New_York').subtract(1, "days").utc().format('YYYY-MM-DD hh:mm:ss');
          reportData.toDate = moment.tz('America/New_York').utc().format('YYYY-MM-DD hh:mm:ss');
        
        break;
      }

      case "last7Days": {
        reportData.fromDate = moment.tz('America/New_York').startOf('day').subtract(7, "days").utc().format('YYYY-MM-DD hh:mm:ss');
        reportData.toDate = moment.tz('America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
        break;
      }

      case "last30Days": {
        reportData.fromDate = moment.tz('America/New_York').startOf('day').subtract(30, "days").utc().format('YYYY-MM-DD hh:mm:ss');
        reportData.toDate = moment.tz('America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
        break;
        
      }

      case "last90Days": {
        reportData.fromDate = moment.tz('America/New_York').startOf('day').subtract(90, "days").utc().format('YYYY-MM-DD hh:mm:ss');
        reportData.toDate = moment.tz('America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
        break;
      }

      case "dateRange": {

        if(report.reportType === 'portOutActivity') {

          if (this.fromDatePortOut) {
            reportData.fromDate = moment.tz(this.fromDatePortOut, 'America/New_York').utc().format('YYYY-MM-DD hh:mm:ss');
          }
          else {
            reportData.fromDate = moment.tz('America/New_York').startOf('day').subtract(90, "days").utc().format('YYYY-MM-DD hh:mm:ss');
          }

          if (this.toDatePortOut) {
            reportData.toDate = moment.tz(this.toDatePortOut, 'America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
          }
          else {
            reportData.toDate = moment.tz('America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
          }

        }

        if(report.reportType === 'portInActivity') {
          if (this.fromDatePortIn) {

            reportData.fromDate = moment.tz(this.fromDatePortIn, 'America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
          }
          else {
            reportData.fromDate = moment.tz('America/New_York').endOf("day").subtract(90, "days").utc().format('YYYY-MM-DD hh:mm:ss');
          }

          if (this.toDatePortIn) {
            reportData.toDate = moment.tz(this.toDatePortIn, 'America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
          }
          else {
            reportData.toDate = moment.tz('America/New_York').endOf("day").utc().format('YYYY-MM-DD hh:mm:ss');
          }

        }
        break;

      }
    }
  }

  onTableRecieve(table) {
    if (table.hasOwnProperty('isReportFound') && !table.isReportFound) {
        this.iuimsg.clearAll();
        this.iuimsg.displayError(new Message(this.DEFAULT_ERROR, this.UNAUTHORIZED_REPORT_ID));
    }
  }

  getSpidLabel(element) {
    return this.spidDisplay.find(x => x.value === element).label;
  }

  getRegionLabel(element) {
    return this.regionsDisplay.find(x => x.value === element).label;
 }

}

